module.exports = __webpack_public_path__ + "static/media/laliga_santander.84464875.png";